import React from 'react'
import Navbar from "./Components/Navbar"
import Hero from "./Components/Hero"

const LandingPage = () => {
  return (
    <>
      <Navbar />
      <Hero />
    </>
  )
}

export default LandingPage
